import React, { Component } from "react";
import Posts from "../components/Posts";

class Category extends Component {
  constructor(props) {
    super(props);

    this.state = {
      posts: [],
      pageName: "",
      postLimit: 0,
      requestSent: false,
      scrollTo: 0
    };

    this.beforeListFetch = this.beforeListFetch.bind(this);
    this.fetchPostListOnScroll = this.fetchPostListOnScroll.bind(this);
    this.fetchPostList = this.fetchPostList.bind(this);
    this.setScrollPosition = this.setScrollPosition.bind(this);
  }

  beforeListFetch() {
    if (this.state.requestSent) return;

    setTimeout(this.fetchPostListOnScroll, 2000);
    this.setState({ requestSent: true, postLimit: this.state.postLimit + 10 });
  }

  fetchPostList() {
    fetch(`${this.props.apiROOT}category/${this.props.match.params.category}/${this.state.postLimit}`)
      .then(res => res.json())
      .then(data => {
        this.setState({
          posts: data.posts,
          pageName: data.pageName,
          postLimit: this.state.postLimit + 10
        });
      });
  }

  fetchPostListOnScroll() {
    fetch(
      `${this.props.apiROOT}category/${this.props.match.params.category}/${this.state.postLimit}`
    )
      .then(res => res.json())
      .then(data => {
        this.setState({
          posts: this.state.posts.concat(data.posts)
        });
        if (data.posts.length > 0) {
          this.setState({
            requestSent: false
          });
        }
      });
  }

  setScrollPosition() {
    let position = window.pageYOffset;
    this.setState({ scrollTo: position });
  }

  componentDidMount() {
    document.title = "Pilgrimagekc - Blog";
    window.addEventListener("scroll", this.setScrollPosition);

    //fetch posts
    this.fetchPostList();
  }

  componentWillReceiveProps(nextProp) {
    if (this.props.post !== nextProp.post) {
      this.state.posts.unshift(nextProp.post);
    }
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.setScrollPosition);
  }

  render() {
    return (
      <React.Fragment>
        <div className="columnTwo">
          <Posts
            posts={this.state.posts}
            pageName={this.state.pageName}
            apiROOT={this.props.apiROOT}
            root={this.props.root}
            beforeListFetch={this.beforeListFetch}
          />
        </div>
      </React.Fragment>
    );
  }
}

export default Category;
